
import React from "react";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { type CaixaLotteryType, CAIXA_LOTTERIES } from "@/utils/caixa";

interface CaixaLotterySelectorProps {
  selectedLottery: CaixaLotteryType;
  onLotteryChange: (lottery: CaixaLotteryType) => void;
  disabled?: boolean;
}

const CaixaLotterySelector: React.FC<CaixaLotterySelectorProps> = ({ 
  selectedLottery, 
  onLotteryChange, 
  disabled = false 
}) => {
  return (
    <div className={`space-y-2 ${disabled ? "opacity-50" : ""}`}>
      <label className="text-sm font-medium">🎰 Loteria</label>
      <Select 
        value={selectedLottery} 
        onValueChange={(value) => onLotteryChange(value as CaixaLotteryType)}
        disabled={disabled}
      >
        <SelectTrigger>
          <SelectValue />
        </SelectTrigger>
        <SelectContent>
          {Object.entries(CAIXA_LOTTERIES).map(([key, lottery]) => (
            <SelectItem key={key} value={key}>
              <div className="flex items-center gap-2">
                <span>{lottery.icon}</span>
                <span>{lottery.name}</span>
              </div>
            </SelectItem>
          ))}
        </SelectContent>
      </Select>
    </div>
  );
};

export default CaixaLotterySelector;
